<template>
    <b-progress class="mt-2" :max="max" show-value height="2em">
      <b-progress-bar :value="done" variant="success"></b-progress-bar>
      <b-progress-bar :value="todo" variant="warning"></b-progress-bar>
      <b-progress-bar :value="rest" variant="primary" v-if="rest!==null"></b-progress-bar>
    </b-progress>
</template>

<script>
export default {
  name: "Progress",
  props: ["done", "todo", "rest"],
  computed:{
    max(){
      return this.rest!==null? this.done+this.todo+this.rest : this.done+this.todo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
